"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconUserThin = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 20 20",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M10,10 C11.8416667,10 13.3333333,8.50833333 13.3333333,6.66666667 C13.3333333,4.825 11.8416667,3.33333333 10,3.33333333 C8.15833333,3.33333333 6.66666667,4.825 6.66666667,6.66666667 C6.66666667,8.50833333 8.15833333,10 10,10 Z M10,11.6666667 C7.775,11.6666667 3.33333333,12.7833333 3.33333333,15 L3.33333333,16.6666667 L16.6666667,16.6666667 L16.6666667,15 C16.6666667,12.7833333 12.225,11.6666667 10,11.6666667 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconUserThin')(IconUserThin);